import "./cargandoDatos.css";

interface CargandoDatosProps {
  // e.g. "Cargando los datos de las órdenes"
  mensaje: string;
  // PrimeIcons class of the document type, e.g. "pi-shopping-cart"
  icono: string;
  // Accent: blue for órdenes, wine for solicitudes (same as their headers)
  tema?: "ordenes" | "solicitudes";
}

/**
 * Shown in place of a maintenance table until its data arrives: big
 * animated icon, the message and a ghost preview of the table rows.
 */
export default function CargandoDatos({
  mensaje,
  icono,
  tema = "ordenes",
}: CargandoDatosProps) {
  return (
    <div
      className={`cd-cargando cd-tema-${tema}`}
      role="status"
      aria-live="polite"
    >
      <div className="cd-icono" aria-hidden="true">
        <span className="cd-anillo" />
        <span className="cd-anillo cd-anillo-2" />
        <i className={`pi ${icono}`} />
      </div>

      <h3 className="cd-mensaje">
        {mensaje}
        <span className="cd-puntos" aria-hidden="true">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </h3>
      <span className="cd-sub">
        Esto puede tardar unos segundos según la cantidad de registros.
      </span>

      <div className="cd-barra" aria-hidden="true">
        <span />
      </div>

      {/* Ghost of the table that is on its way */}
      <div className="cd-fantasma" aria-hidden="true">
        {[0, 1, 2, 3, 4].map((fila) => (
          <div key={fila} className="cd-fila">
            <span className="cd-celda cd-celda-toggle" />
            <span className="cd-celda cd-celda-lg" />
            <span className="cd-celda" />
            <span className="cd-celda cd-celda-sm" />
            <span className="cd-celda cd-celda-sm" />
            <span className="cd-celda cd-celda-lg" />
            <span className="cd-celda cd-celda-pill" />
          </div>
        ))}
      </div>
    </div>
  );
}
